import AbstractCanvasTransformTool from "ui/canvas/transforms/AbstractCanvasTransformTool";
import {SCENE_FRAMES} from "ui/config";

/**
 * Transform layer: changes alpha value for each selected frame
 */
export default class CanvasAlpha extends AbstractCanvasTransformTool {
	/**
	 * @param {number} alphaFrom
	 * @param {number} alphaTo
	 */
	constructor(alphaFrom, alphaTo) {
		super();
		this._alphaFrom = alphaFrom;
		this._alphaTo = alphaTo;
		this._alphaByFrames = [];
	}

	/**
	 * @inheritDoc
	 */
	_isNeedKeyframesForSelection(fromFrame, toFrame) {
		return fromFrame !== toFrame && this._alphaFrom !== this._alphaTo;
	}

	/**
	 * @inheritDoc
	 */
	async _prepare(layer, fromFrame, toFrame) {
		const len = toFrame - fromFrame;
		let alpha, alphaStep;

		this._alphaByFrames = new Array(SCENE_FRAMES).fill(0);

		if (len === 0) {
			alphaStep = 0;
			alpha = this._alphaFrom;
		} else if (this._alphaFrom === this._alphaTo) {
			alphaStep = 0;
			alpha = this._alphaFrom;
		} else {
			alphaStep = (this._alphaTo - this._alphaFrom) / len;
			alpha = this._alphaFrom;
		}

		for (let i = fromFrame; i <= toFrame; i++) {
			this._alphaByFrames[i] = alpha;
			alpha += alphaStep;
		}
	}

	/**
	 * @inheritDoc
	 */
	_transformImage(ctx, mat, frameIndex) {
		ctx.globalAlpha = this._alphaByFrames[frameIndex];
	}
}
